import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Hero from "./sections/Hero";
import Banner from "./sections/Banner";
import Gallery from "./sections/Gallery";
import Mypage from "./sections/mypage";
import Productgrid from "./sections/Productgrid";
import MetaData from "../components/MetaData";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../actions/productActions";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { toast } from "react-toastify";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { products, loading, error } = useSelector(
    (state) => state.productsState
  );
  const [currentGoldPrice, setCurrentGoldPrice] = useState(0);

  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    dispatch(getProducts());

    // Fetch Gold Price once for all products
    const fetchGoldPrice = async () => {
      try {
        const { data } = await axios.get("/goldprice/admin/show");
        if (data && data.length > 0) {
          setCurrentGoldPrice(data[0].goldprice);
        }
      } catch (err) {
        console.error("Gold price fetch failed", err);
      }
    };
    fetchGoldPrice();
  }, [dispatch, error]);

  // Logic for Product Sections
  const trendingProducts = products
    ? [...products].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 4)
    : [];

  const topDesignProducts = products
    ? [...products].sort((a, b) => b.ratings - a.ratings).slice(0, 4)
    : [];

  const categoriesList = ["Rings", "Earrings", "Bangles", "Necklace"];

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <MetaData heading={"Premium Jewellery Store"} />
          <div className="bg-white">
            <Hero />
            <Banner />

            {/* Category Discovery Grid */}
            <div className="container mx-auto px-4 mt-20">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4 tracking-tight">Our Collections</h2>
                <div className="w-24 h-1 bg-yellow-600 mx-auto mb-4 rounded-full"></div>
                <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                  Reflecting your unique style and celebrating life's precious moments with our curated collections.
                </p>
              </div>
              <Gallery />
            </div>

            {/* Trending Now Section */}
            {trendingProducts.length > 0 && (
              <div className="container mx-auto px-4 mt-24 text-center">
                <div className="mb-10 text-center ">
                  <h2 className="text-3xl font-bold text-gray-900">Trending Now</h2>
                  <p className="text-gray-500 mt-2">Discover our most recent styles catching everyone's eye.</p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                  {trendingProducts.map((product) => (
                    <Productgrid key={product._id} product={product} goldPrice={currentGoldPrice} />
                  ))}
                </div>
              </div>
            )}

            {/* Top Designs Section */}
            {topDesignProducts.length > 0 && (
              <div className="bg-gray-50 py-24 mt-24 text-center">
                <div className="container mx-auto px-4">
                  <div className="mb-16">
                    <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">Exquisite Top Designs</h2>
                    <p className="text-gray-500 uppercase tracking-widest text-sm font-semibold">Customer Favorites & Highly Rated</p>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {topDesignProducts.map((product) => (
                      <Productgrid key={product._id} product={product} goldPrice={currentGoldPrice} />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Category Wise Showcase */}
            {/* <div className="container mx-auto px-4 my-24">
                {categoriesList.map((category) => {
                    const filtered = products ? products.filter(p => p.category === category).slice(0, 4) : [];
                    if (filtered.length === 0) return null;
                    return (
                        <div key={category} className="mb-24 last:mb-0">
                            <div className="flex items-center justify-between mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 flex items-center">
                                    <span className="w-8 h-px bg-yellow-600 mr-4"></span>
                                    {category} Collection
                                </h2>
                                <button 
                                    onClick={() => navigate(`/products/${category}`)}
                                    className="text-yellow-600 font-semibold hover:underline border border-yellow-600 px-4 py-1 rounded transition-colors hover:bg-yellow-600 hover:text-white"
                                >
                                    View All
                                </button>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                                {filtered.map((product) => (
                                    <Productgrid key={product._id} product={product} goldPrice={currentGoldPrice} />
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div> */}

            {/* <Mypage /> */}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Home;
